<div class="container"
     [style.height.px]="slotHeight"
     [style.border-width.px]="BORDER_WIDTH"
     (click)="onSeeSessionClicked()">
    <div class="top">
        <div class="drag-handle">
            <ng-content select="[before-title-section]"></ng-content>
        </div>

        <div class="title">
          {{ slot?.session?.name }}
            <span class="duration" *ngIf="slot?.session?.totalTime! > 1800">{{ slot?.session?.totalTime | secondsToDHM:true | default:'-' }}</span>
        </div>

        <div class="more-section"
             (click)="onMoreSectionClicked($event)">
            <ng-content select="[more-section]"></ng-content>
        </div>
    </div>
<!--
    <table-histogram-chart *ngIf="slot && slot.session && slot.session.histogramData"
                           class="adn"
                           [showOnlyBar]="true"
                           [rows]="slot.session.histogramData.rows"
                           [columns]="slot.session.histogramData.cols"
                           [values]="slot.session.histogramData.values">
    </table-histogram-chart>
    -->
</div>
